<template>
  <div class="text"> 
    <div id="breadcrumb">Dürrenmatt Stoffe /<br />Genese / <strong>Segmentierung <em>Vallon de l'Ermitage</em></strong></div>
    <div class="nav-header" id="vallonHeader">
    </div>
    <Burger navType="Genese" />
    <GeneseMenu ref="genesemenu"/> 
    <keep-alive>
      <div class="custom-scroller" id="segvalloncontainer" ref="segvalloncontainer" v-html="this.table" v-show="isReady" v-cloak></div>
    </keep-alive>
  </div>
</template>
<script>

import axios from "axios";
import Burger from '@/components/Burger.vue'
import GeneseMenu from '@/components/GeneseMenu.vue'
import segmentClickEventHandler from "@/components/Scripts/segmentClickEventHandler"

const base = axios.create({
  baseURL: "/",
});

export default {
  name: 'SegVallon',
  components: {
    Burger,
    GeneseMenu
  },
  data: () => ({
    table: "",
    component:"BookContainer",
    callFromRegister: false,
    showNavArrowBox: false,    
    pagenr: 1,
    isReady: true
  }),


  methods: {  
    segmentClickEventHandler,
    initPage() {
      this.loadTable()
    },
    scrollToAnchor() {
        let hash =  (document.URL.split('#').length > 1) ? document.URL.split('#')[1] : null;
        if(hash !== null) {
            let target = document.getElementById(hash)
            if (target !== null) { 
                let scrollContainer = document.getElementById("segvalloncontainer") 
                //target.style.backgroundColor = 'yellow';
                scrollContainer.scrollTop = target.offsetTop -150 //- scrollContainer.scrollTop + 50
            }
        }
    },

    loadTable() {
      let links = []
      let url = ""
      url = "stoffe_Tableheader_Segmentierung_Vallon.html"
      base
        .get(url)
        .then((response) => {
          this.table = response.data
          this.isReady = true
        })
    },


/*** setBrowserBackLink
 *  param hash id
 */
  setBrowserBackLink (id) {
  if(id || id.length !== 0) {    
    window.location.hash =  id 
  } 
}    


  },
 watch: { 
      $route(to, from) { 
          if (to.path.includes("segvallon") ){ 
            this.scrollToAnchor()
          }
      }
  },
  mounted() {

      this.initPage()
        this.$refs.segvalloncontainer.removeEventListener('click', this.segmentClickEventHandler, false)   
        this.$refs.segvalloncontainer.addEventListener('click', this.segmentClickEventHandler, false) 
        this.scrollToAnchor() 
  },
  updated() {
      this.scrollToAnchor() 
  }
}

</script>

<style lang="scss"  >

@import "@/assets/css/_typo.scss";
@import "@/assets/css/_variables.scss";

[v-cloak] {display: none}

#app {
    margin-bottom: 0;
}

#segvalloncontainer {
  margin: 100px auto;
  overflow-x: auto;
  height: calc(100vh - 125px);
  margin-bottom: 0;
  overflow-y: scroll;

  span.verweis {
    cursor:pointer;
    color: $color-red;
    &:hover {
      text-decoration: underline;  
    }   
  }

  table thead  {
  position: sticky ;
  top: 0px;
  z-index: 1;
  padding-bottom: 3px;
  background-color: #eaeaea;

}

  table.Tableheader_Segmentierung_Vallon  { 
      border-collapse: collapse;
    max-width:100%;
    width: 100%;
    font-family: $font-family-herausgeber-regular ;
    font-size: 0.9rem;
    line-height: 1rem;
    //border-collapse: separate;
    //border-spacing: 15px 0;
    //margin: 0 -15px;
    margin: 0;
    text-align: left;

    td , th{
      padding: 5px 5px 15px 5px; 
      
      vertical-align: top;
      margin: 0 0 0 10px;
      &.paginierung {
        display:none;
      }
      //border: 1px solid red;
    }
    th {
        font-weight: bold;
        background-color: #eaeaea;
        &.Stofftitel {
            max-width:7%;
        }
         &.Gattung {
            max-width:15%;
        } 
         &.Segm_1990 {
            max-width:250px;
        }  
         &.Seiten_1990 {
            max-width:100px;
            width: 100px;
        }   
         &.Sigle {
            max-width:7%;            
        }
         &.Erzaehlzeit {
            max-width:5%;
        }  
        &.Entstehungszeit {
            max-width:5%;
        } 
        &.Verweise {
             max-width:33%;
             width: 400px;
        }                
    }

    td{
        padding-top: 3px;
        border-bottom: 1px solid black !important;
        &.Stofftitel {
            max-width:7%;
        }
        &.Gattung {
            max-width:15%;
        }
        &.Segm_1990 {
            max-width:250px;
        }  
         &.Seiten_1990 {
            max-width:100px;
            width: 100px;
        }   
         &.Sigle {
            max-width:7%;            
        }
         &.Erzaehlzeit {
            max-width:5%;
        }  
        &.Entstehungszeit {
            max-width:5%;
        } 
        &.Verweise {
             max-width:33%;
             width: 400px;
        }                                                        
    }
  
    .verweis {
      position: relative !important;
      margin-top: 0 !important;
      right: unset !important;
      width: auto !important;
    }
  }
}


th {
  background: white;
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}

</style>
